import { toNotificationProjection } from "./notification";
const storageListNotificationsView = ({ storage }) => async () => {
    const notificationDtos = await storage.list();
    return notificationDtos.map(toNotificationProjection);
};
export { storageListNotificationsView };
